import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Box,
    Dialog,
    IconButton,
    Button,
    Slide,
    Theme,
    Toolbar,
    Paper,
    Typography,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    LinearProgress,
    Avatar
} from "@mui/material";
import {CloseRounded} from "@mui/icons-material";
import {useTheme} from '@mui/material/styles';
import {useParams} from "react-router-dom";
import {ContainerClasses} from '../../themes/containerClasses'
import {storeListViewConfig,
        storeListConfig,
        retrieveObjectInformation,
        switchPaginatorPage,
        retrieveSortedRecords,
        retrieveFilteredRecords,
        selectError,
        selectObjectMetadata,
        selectRecords,
        selectSelectedListView,
        selectSelectedListViewColumns,
        selectListViews,
        selectObjectPage,
        selectActions,
        selectListConfig,
        selectListViewConfig,
        selectChart,
        selectIsFetching as selectIsFetchingObjectInformation} from "./objectSlice";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {ListSelectorComponent} from "../../components/listSelector/ListSelector";
import {ErrorComponent} from "../../components/error/Error";
import {ListComponent} from "../../components/list/List";
import {ListViewModel,
        ListViewFilterModel,
        ActionModel,
        ObjectModel} from "../../models/models";
import {ListConfigurationModel,
        ListViewConfigurationModel,
        ListDisplayTypeType} from "../../models/modelsListConfiguration";
import {SortOrderModel,
        BarChartUIPreferenceModel} from '../../models/modelsUserConfiguration';
import {setSelectedTabObject} from "../../app/globalLayoutSlice";
import {getAppName,
        getObjectName} from "../../utils/helperRouter";
import { useNavigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { ActionsComponent } from "../../components/actions-o/Actions";
import { CelebrationDemoComponent } from "../../components/celebrations/CelebrationDemo";
import { ObjectAvatar } from "../../components/icons/ObjectAvatar";

export const ObjectScreen = () => {

  let {appName, objectName} = useParams();

  const theme = useTheme();
  const styles = ContainerClasses();
  const {accessToken, onInvalidToken} = useAuth();

  const dispatch = useDispatch<any>();

//  const authToken = useSelector(selectAuthenticationToken);
  const fetchError = useSelector(selectError);
  const records = useSelector(selectRecords);
  const objectMetadata = useSelector(selectObjectMetadata);
  const selectedListView = useSelector(selectSelectedListView);
  const chart = useSelector(selectChart);
  const objectPage = useSelector(selectObjectPage);
  const availableActions = useSelector(selectActions);
  const listConfig = useSelector(selectListConfig);
  const listViewConfig = useSelector(selectListViewConfig);
  const selectedListViewColumns = useSelector(selectSelectedListViewColumns);
  const listViews = useSelector(selectListViews);
  const isFetchingObjectInformation = useSelector(selectIsFetchingObjectInformation);


  useEffect(() => {
      const thisObjectName = getObjectName(objectName);
      const thisListConfig = null;
      const thisListViewConfig = null;
      const thisBarChartConfig = null;
      dispatch(retrieveObjectInformation(thisObjectName, null, thisListConfig, thisListViewConfig, thisBarChartConfig, accessToken, false, onInvalidToken));
      dispatch(setSelectedTabObject(thisObjectName));

  }, [objectName]); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = isFetchingObjectInformation;

  const selectListView = (thisListView: ListViewModel) => {
      const thisObjectName = getObjectName(objectName)
      const thisListConfig = null;
      const thisListViewConfig = null;
      const thisBarChartConfig = null;
      dispatch(retrieveObjectInformation(thisObjectName, thisListView.ApiName_sys, thisListConfig, thisListViewConfig, thisBarChartConfig, accessToken, true, onInvalidToken));
  }

  const switchPaginatorPageB = (listViewConfig: ListViewConfigurationModel, newPage: number) => {
    const thisObjectName = getObjectName(objectName)
    dispatch(switchPaginatorPage(thisObjectName, selectedListView?.ApiName_sys, listConfig, listViewConfig, newPage, accessToken, onInvalidToken));
  }
  const loadSortedRecords = (listViewConfig: ListViewConfigurationModel, sortOrders: SortOrderModel[]) => {
    const thisObjectName = getObjectName(objectName)
    dispatch(retrieveSortedRecords(thisObjectName, selectedListView?.ApiName_sys, listConfig, listViewConfig, sortOrders, accessToken, onInvalidToken));
  }
  const loadFilteredRecords = (listConfig: ListConfigurationModel) => {
    const thisObjectName = getObjectName(objectName)
    dispatch(retrieveFilteredRecords(thisObjectName, selectedListView?.ApiName_sys, listConfig, accessToken, onInvalidToken));
  }
  const handleDatabaseSearch = (listViewConfig: ListViewConfigurationModel) => {
      const thisObjectName = getObjectName(objectName)
      const thisListConfig = null;
      const thisBarChartConfig = null;
      dispatch(retrieveObjectInformation(thisObjectName, selectedListView?.ApiName_sys, thisListConfig, listViewConfig, thisBarChartConfig, accessToken, true, onInvalidToken));
  }
  const handleFrontendSearch = (listViewConfig: ListViewConfigurationModel) => {
    dispatch(storeListViewConfig(listViewConfig));
  }
  const setBarChartConfig = (listView: ListViewModel, barChartGroups: BarChartUIPreferenceModel[]) => {
    const thisObjectName = getObjectName(objectName)
    const thisListConfig = {...listConfig,
                            displayType: 'BarChart' as ListDisplayTypeType};
    const thisListViewConfig = null;
    dispatch(retrieveObjectInformation(thisObjectName, listView.ApiName_sys, thisListConfig, thisListViewConfig, barChartGroups, accessToken, true, onInvalidToken));
  }

  const setListViewConfig = (listView: ListViewModel, listViewConfig: ListViewConfigurationModel) => {
    const thisObjectName = getObjectName(objectName)
    const thisListConfig = {...listConfig,
                            displayType: 'List' as ListDisplayTypeType};
    const thisBarChartConfig = null
    dispatch(retrieveObjectInformation(thisObjectName, listView.ApiName_sys, thisListConfig, listViewConfig, thisBarChartConfig, accessToken, true, onInvalidToken));
  }



  const navigate = useNavigate();
  const selectRecord = (recordUuid: string) => {
    const thisAppApiName = getAppName(appName)
    const thisObjectApiName = getObjectName(objectName)
    navigate(`/${thisAppApiName}/${thisObjectApiName}/${recordUuid}`);
  }


  /******************************/


  return (
     <Box>

       <LinearProgress
         color="primary"
         sx={{visibility: isLoading ? "visible" : "hidden"}}
      />

       {fetchError !== null &&
           <ErrorComponent
              errorMessage = {fetchError}
           />
       }

       {/*
         put standard components here
       */}

       {fetchError === null &&
        <Card sx={styles.containerCard}>
           <Box sx={styles.containerRowB}>
              {objectMetadata &&
                <ObjectAvatar
                  objectMetadata={objectMetadata}
                  size={40}
                />
              }

              <CardActions>
                {/*<CelebrationDemoComponent/>*/}
                <ActionsComponent
                  availableActions={availableActions}
                />
              </CardActions>

           </Box>

           <Box sx={styles.containerRowB}>
              <ListSelectorComponent
                 selectedList = {selectedListView}
                 availableLists = {listViews}
                 selectList = {selectListView}
              />
           </Box>

           <CardContent>
             {selectedListView &&
               <ListComponent
                  listView={selectedListView}
                  chart={chart}
                  records={records.filter((thisRecord) => thisRecord.accessRights.includes('read'))}
                  switchPaginatorPage={switchPaginatorPageB}
                  loadSortedRecords={loadSortedRecords}
                  loadFilteredRecords={loadFilteredRecords}
                  onDatabaseSearch={handleDatabaseSearch}
                  onFrontendSearch={handleFrontendSearch}
                  setBarChartConfig={setBarChartConfig}
                  setListViewConfig={setListViewConfig}
                  onSave = {selectListView}
                  selectRecord={selectRecord}
                  listConfig={listConfig}
                  listViewConfig={listViewConfig}
                />
              }
           </CardContent>
        </Card>
      }
     </Box>

);
};
